// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3ooWr","noInteraction":"EventWrapper_noInteraction__2-4D4","pointerPassthrough":"EventWrapper_pointerPassthrough__1eDlF"};